import { notifyMutationError } from '@inquiries/-lib/handleInquiryCompletedError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { updateInquiryCoordination } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export function useUpdateInquiryCoordination(inquiryId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, content }: { id: number; content: string }) => {
      return updateInquiryCoordination(inquiryId, id, { content })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.coordinations(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.actionLogs(inquiryId) })
      toast.success('調整状況を更新しました')
    },
    onError: (error: Error) => {
      notifyMutationError(error, '調整状況の更新に失敗しました')
    },
  })
}
